<header class="topbar">
  <button class="iconbtn" (click)="peruuta()" type="button" [attr.aria-label]="'tositteet.lisaa-tositteita.sivu.takaisin-aria' | translate | async">
    <span class="material-icons">arrow_back</span>
  </button>
  <h1>{{ 'kuitit.muokkaa.otsikko-muokkaa' | translate | async }}</h1>
  <div class="right-spacer" aria-hidden="true"></div>
</header>

@if (lomake) {
  <main class="page">
    <article class="block">
      <div class="block-fields">
        <div class="grid">
          @if (showMaksutavat) {
            <div class="full">
              <app-maksutapa-valinta [valittu]="kuitti?.maksutapa" (valittuChange)="paivitaMaksutapa($event)"></app-maksutapa-valinta>
              @if (virheet(maksutapa)?.required && (maksutapa().dirty() || maksutapa().touched())) {
                <mat-error>{{ 'kuitit.muokkaa.validation.maksutapa.required' | translate | async }}</mat-error>
              }
            </div>
          }

          @if (showPvm) {
            @if (dateSelectionType === 'day') {
              <mat-form-field>
                <mat-label>{{ pvmText }}</mat-label>
                <input numberDatePicker matInput type="text" [formField]="tositteenPvm" [matDatepicker]="pickerDay" [min]="minDate" [max]="maxDate" autocomplete="1" data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="pickerDay"></mat-datepicker-toggle>
                <mat-datepicker #pickerDay></mat-datepicker>
                @if (tositteenPvm().dirty() || tositteenPvm().touched()) {
                  @if (virheet(tositteenPvm)?.required) {
                    <mat-error>{{ 'kuitit.muokkaa.validation.pvm.required' | translate | async }}</mat-error>
                  }
                  @if (virheet(tositteenPvm)?.matDatepickerParse) {
                    <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerParse' | translate | async }}</mat-error>
                  }
                  @if (virheet(tositteenPvm)?.matDatepickerMax) {
                    <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMax' | translate | async }}</mat-error>
                  }
                  @if (virheet(tositteenPvm)?.matDatepickerMin) {
                    <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMin' | translate | async }}</mat-error>
                  }
                }
              </mat-form-field>
            } @else {
              <mat-form-field>
                <mat-label>{{ pvmText }}</mat-label>
                <input monthPicker numberDatePicker matInput type="text" [formField]="tositteenPvm" [matDatepicker]="pickerMonth" [min]="minDate" [max]="maxDate" autocomplete="1" data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="pickerMonth"></mat-datepicker-toggle>
                <mat-datepicker #pickerMonth></mat-datepicker>
                @if (tositteenPvm().dirty() || tositteenPvm().touched()) {
                  @if (virheet(tositteenPvm)?.required) {
                    <mat-error>{{ 'kuitit.muokkaa.validation.pvm.required' | translate | async }}</mat-error>
                  }
                  @if (virheet(tositteenPvm)?.matDatepickerParse) {
                    <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerParse' | translate | async }}</mat-error>
                  }
                  @if (virheet(tositteenPvm)?.matDatepickerMax) {
                    <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMax' | translate | async }}</mat-error>
                  }
                  @if (virheet(tositteenPvm)?.matDatepickerMin) {
                    <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMin' | translate | async }}</mat-error>
                  }
                }
              </mat-form-field>
            }
          }

          @if (!hideSum) {
            <mat-form-field>
              <mat-label>{{ summaText }}</mat-label>
              <input decimalNumberField matInput type="text" inputmode="decimal" [formField]="summa" autocomplete="1" data-lpignore="true" />
              <span matSuffix>€</span>
              @if (virheet(summa)?.required && (summa().dirty() || summa().touched())) {
                <mat-error>{{ 'kuitit.muokkaa.validation.summa.required' | translate | async }}</mat-error>
              }
              @if (virheet(summa)?.min && (summa().dirty() || summa().touched())) {
                <mat-error>{{ 'kuitit.muokkaa.validation.summa.min' | translate | async }}</mat-error>
              }
              @if (virheet(summa)?.max && (summa().dirty() || summa().touched())) {
                <mat-error>{{ 'kuitit.muokkaa.validation.summa.max' | translate | async }}</mat-error>
              }
              @if (virheet(summa)?.nolla && (summa().dirty() || summa().touched())) {
                <mat-error>{{ 'kuitit.muokkaa.validation.summa.nolla' | translate | async }}</mat-error>
              }
              @if ((summa().value() ?? 0) < 0) {
                <mat-hint class="field-hint">{{ 'tositteet.lisaa-tositteita.tosite-kortti.hyvitys-vihje' | translate | async }}</mat-hint>
              }
            </mat-form-field>
          }

          <div class="full">
            <app-toimittaja-kentta [valittuNimi]="toimittajanNimi().value()" [uusiToimittajaLomake]="uusiToimittaja" [pakollinen]="false" (valittuNimiChange)="paivitaToimittajanNimi($event)" (valittuAvainChange)="paivitaToimittajaAvain($event)"></app-toimittaja-kentta>
          </div>

          @if (naytaProjektitObservable | async) {
            <div class="full">
              <app-projekti-kentta [valittuAvain]="projektiAvain().value()" (valittuAvainChange)="paivitaProjektiAvain($event)"></app-projekti-kentta>
            </div>
          }

          @if (alvPortaat && alvPortaat.length > 0) {
            <mat-form-field class="full">
              <mat-label>{{ 'kuitit.muokkaa.alv' | translate | async }}</mat-label>
              <mat-select [formField]="alvVahennysoikeus">
                @for (porras of alvPortaat; track porras) {
                  <mat-option [value]="porras">{{ porras }} %</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if (maksajaTaiMaksunSaaja) {
            <div class="full el-kommentti">{{ maksajaTaiMaksunSaaja }}</div>
          }

          <mat-form-field class="full">
            <mat-label>{{ 'kuitit.muokkaa.lisatiedot' | translate | async }}</mat-label>
            <textarea matInput [formField]="lisatiedot" cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="10" autocomplete="1"></textarea>
          </mat-form-field>

          @if (kirjanpitajanKommentti) {
            <div class="full kirj-kommentti">{{ 'kuitit.muokkaa.kirjanpitajan-kommentti' | translate | async }}: {{ kirjanpitajanKommentti }}</div>
          }
          @if (kuitti.userApiMessage) {
            <div class="full tosite-api-msg">{{ kuitti.userApiMessage }}</div>
          }

          @if (virheviestiEiKuvia) {
            <div class="full error-text">{{ virheviestiEiKuvia }}</div>
          }
          @if (virheviestiLatausOnKesken) {
            <div class="full error-text">{{ virheviestiLatausOnKesken }}</div>
          }
          @if (virheviestiPysyva) {
            <div class="full error-text">{{ virheviestiPysyva }}</div>
          }
          @if (virheviestiTallennus) {
            <div class="full error-text">{{ virheviestiTallennus }}</div>
          }
          @if (kuvavirheAvain) {
            <div class="full error-text">{{ kuvavirheAvain | translate: kuvavirheParametrit | async }}</div>
          }
          @if ((latausvirheetObservable | async)?.length > 0) {
            <div class="full error-text" style="text-align: left">
              {{ 'lasku.tiedoston-lahettaminen-epaonnistui-alku' | translate | async }}
              <ul>
                @for (virhe of latausvirheetObservable | async; track virhe) {
                  <li>{{ virhe }}</li>
                }
              </ul>
              {{ 'lasku.tiedoston-lahettaminen-epaonnistui-loppu' | translate | async }}
            </div>
          }
        </div>
      </div>

      <div class="block-image-col">
        <input #fileInput type="file" accept="image/*,application/pdf,.heic,.heif" multiple style="display: none" (change)="fileChanged($event)" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.valitse-tiedosto-aria' | translate | async" />
        <div class="page-toolbar">
          <div class="pager">
            <button type="button" class="pg-btn" [disabled]="nykyinenSivuIndeksi === 0" (click)="edellinenSivu()" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.edellinen-tiedosto-aria' | translate | async">
              <span class="material-symbols-outlined">chevron_left</span>
            </button>
            <span class="pg-label">{{ 'tositteet.lisaa-tositteita.tosite-kortti.tiedosto-teksti' | translate | async }} {{ nykyinenSivuIndeksi + 1 }} / {{ ((sivutObservable | async) ?? []).length }}</span>
            <button type="button" class="pg-btn" [disabled]="nykyinenSivuIndeksi >= ((sivutObservable | async) ?? []).length - 1" (click)="seuraavaSivu()" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.seuraava-tiedosto-aria' | translate | async">
              <span class="material-symbols-outlined">chevron_right</span>
            </button>
          </div>
          <div class="spacer"></div>
          <button type="button" class="add-page" (click)="avaaTiedostonValinta()" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.lisaa-tiedosto-aria' | translate | async">
            <span class="material-symbols-outlined">add</span>
            {{ 'tositteet.lisaa-tositteita.tosite-kortti.lisaa-tiedosto' | translate | async }}
          </button>
        </div>

        @if (nykyinenSivuObservable | async; as sivu) {
          <div class="page-file">
            <span class="page-name">{{ sivu.nimi || ('tositteet.lisaa-tositteita.tosite-kortti.ei-tiedostoa' | translate | async) }}</span>
            @if (((sivutObservable | async) ?? []).length > 1 && !sivu.lukittu) {
              <button type="button" class="icon-btn-small" (click)="poistaSivuKlikattu(nykyinenSivuIndeksi, $event)" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.poista-tiedosto-aria' | translate | async">
                <span class="material-symbols-outlined">close</span>
              </button>
            }
          </div>
          @if (sivu.kuvaUrlit.length > 0) {
            <app-tiedoston-sivut [kuvaUrlit]="sivu.kuvaUrlit"></app-tiedoston-sivut>
          } @else {
            <div class="receipt-image" [class.is-clickable]="!!sivu.esikatselukuva" [attr.role]="sivu.esikatselukuva ? 'button' : null" [attr.tabindex]="sivu.esikatselukuva ? 0 : null" (click)="naytaSuurempana()" (keydown.enter)="naytaSuurempana()">
              @if (sivu.esikatselukuva) {
                <img [src]="sivu.esikatselukuva" [alt]="sivu.nimi" />
                <span class="zoom-hint"><span class="material-symbols-outlined" style="font-size: 18px">zoom_in</span></span>
              }
            </div>
          }
        }

        @if ((latausvirheetObservable | async)?.length && (donePercentageObservable | async) !== null) {
          <div style="width: 100%; margin-top: 1em; text-align: center">
            <mat-progress-bar mode="determinate" [value]="donePercentageObservable | async"></mat-progress-bar>
            <div style="padding-top: 3px; font-size: 12px">{{ 'kuitit.muokkaa.ladataan' | translate | async }}</div>
          </div>
        }
      </div>
    </article>
  </main>

  <div class="savebar">
    <div class="savebar-viestit">
      @if (naytaTallennuksenEsto) {
        <div class="tallennus-esto" role="alert">
          <span class="material-symbols-outlined" aria-hidden="true">error</span>
          {{ 'kuitit.muokkaa.validation.tallennus-estyi' | translate | async }}
        </div>
      }
    </div>
    <button class="btn-primary" type="button" (click)="save()">{{ 'yleiset.tallenna' | translate | async }}</button>
  </div>
}

@if (naytaModal) {
  <div class="image-modal" (click)="suljeModal()" (keydown.escape)="suljeModal()" tabindex="-1">
    <button type="button" class="modal-close" (click)="suljeModal()" aria-label="Sulje">
      <span class="material-symbols-outlined">close</span>
    </button>
    <div class="modal-content" (click)="$event.stopPropagation()">
      <img [src]="$safeNavigationMigration((nykyinenSivuObservable | async)?.esikatselukuva)" [alt]="$safeNavigationMigration((nykyinenSivuObservable | async)?.nimi)" />
    </div>
  </div>
}
